/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type User = {
    id: string;
    source: User.source;
    githubId: string | null;
    googleId: string | null;
    forename: string;
    username: string;
    surname: string | null;
    email: string;
    domain: string;
    personal: boolean;
    emailVerified: boolean;
    created: string;
    updated: string;
    _object: User._object;
};
export namespace User {
    export enum source {
        GOOGLE = 'google',
        EMAIL = 'email',
        GITHUB = 'github',
    }
    export enum _object {
        USER = 'user',
    }
}

